var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header-v2"},[_c('TopBar'),_c('NavBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }